import {sendAnalyticsEvent} from '#/analytics/analytics';
import {ContentTileWithTitle} from '#/atoms/content-tile';
import {ActionMenuContext} from '#/components/actionmenu/action-menu';
import {GraphRangeContext, GraphRangeProvider} from '#/components/graphs/graph-range-selector';
import LandMarketDataGraph from '#/components/graphs/land-market-data-graph';
import {TradingViewModal} from '#/components/trading-view/trading-view-modal';
import {DefaultChildren} from '#/utils/utils';
import {AnimatePresence} from 'framer-motion';
import {FunctionComponent, useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';

export const ActionMenuContentSectionMarketPrice: FunctionComponent<DefaultChildren> = () => {
  const {land} = useContext(ActionMenuContext);

  const {t: tBase} = useTranslation('translation');
  const {t} = useTranslation('translation', {
    keyPrefix: 'pages.actionMenu.information.sections.information.contentSection.marketData',
  });

  const [isTradingViewOpen, setIsTradingViewOpen] = useState(false);
  const onTradingViewClick = () => {
    setIsTradingViewOpen(true);
    sendAnalyticsEvent.advancedCharts();
  };
  const onTradingViewClose = () => setIsTradingViewOpen(false);

  return (
    <>
      <ContentTileWithTitle title={t('title')}>
        <GraphRangeProvider>
          <GraphRangeContext.Consumer>
            {({graphRange}) => <LandMarketDataGraph land={land} graphRange={graphRange} />}
          </GraphRangeContext.Consumer>
        </GraphRangeProvider>

        <button
          className='w-full mt-4 text-xs text-deepblue hover:opacity-70 cursor-pointer'
          onClick={onTradingViewClick}
        >
          {tBase('pages.advancedTradingView.title')}
        </button>

        {isTradingViewOpen && (
          <AnimatePresence>
            <TradingViewModal key={'TradingViewModalKey'} land={land} onCloseModal={onTradingViewClose} />
          </AnimatePresence>
        )}
      </ContentTileWithTitle>
    </>
  );
};
